import { DOMHelper } from "../Helpers/DOMHelper.js";
import { PmDatalayer } from "./PmDatalayer.js";

export class PmVDPDatalayer extends PmDatalayer {

    constructor(pmDrsApi) {
        super(pmDrsApi);
    }

    init() {
        if(!('VDP' in window)){
            console.log("skip PmVDPDatalayer, no VDP");
            return;
        }
        this.addHandlers();
    }

    addHandlers() {
        var dataLayer = this;

        var generalClickEvents = [
            { selector: '.cta-button', element: 'cta button' },        
        ];

        generalClickEvents.forEach((item)=> {            
            DOMHelper.addHandler(
                item.selector, 
                "click", 
                (event) => {                    
                    console.log("Pm dataLayer selector: " + item.selector);
                    dataLayer.ctaClickEvent(PmVDPDatalayer.DATALAYER_SECTION, item.element, event.target);
                }
            );
        });
    }


}

PmVDPDatalayer.DATALAYER_SECTION = "vdp";